import React from 'react';
import { useTranslate } from 'react-redux-multilingual';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTimesCircle, faTrash, faEdit } from '@fortawesome/free-solid-svg-icons';
import { DeleteActionButton } from "@gull";
import { OverlayTrigger, Tooltip } from "react-bootstrap";

const SupplementListDetailItem = (props) => {
    const t = useTranslate();

    return(
        <>
            {props.from=="erp" &&
                <>
                    <OverlayTrigger
                        placement="bottom"
                        overlay={<Tooltip>{t('selectArticlePrice')}</Tooltip>}
                    >
                        <span
                            className="position-absolute text-primary pointer"
                            style={{cursor:'pointer', top:"5px", left:"5px"}}
                            onClick={()=>props.editAction(props.supplementListDetail)}
                        >
                            <FontAwesomeIcon icon={faEdit} />
                        </span>
                    </OverlayTrigger>
                    <DeleteActionButton spanClass='position-absolute text-danger pointer' spanStyle={{top:"5px", right:"5px"}} deleteFunctionArgument={props.supplementListDetail.id} actionType={'typeDeleteX'} nameType={'delete'} toDelete={props.supplementListDetail.article.name} customClickEvent={props.removeItem}/>
                </>
            }
            {props.from=="pos" && props.multiple_choice && props.resetAction &&
                <>
                    <OverlayTrigger
                        placement="bottom"
                        overlay={
                            <Tooltip>
                                {t('resetQuantity')}
                            </Tooltip>
                        }
                    >
                        <span 
                            className={'position-absolute text-danger pointer'}
                            style={{cursor:'pointer', top:"5px", right:"5px"}} 
                            onClick={() => props.resetAction(props.supplementListDetail.article)}
                        >
                            <FontAwesomeIcon icon={faTimesCircle} />
                        </span>
                    </OverlayTrigger>  
                    <OverlayTrigger
                        placement="bottom"
                        overlay={
                            <Tooltip>
                                {t('quantity')}
                            </Tooltip>
                        }
                    >
                        <span
                            className={'position-absolute pastille pointer'}
                            style={{cursor:'pointer', top:"5px", left:"5px"}} 
                        >
                            {props.quantity}
                        </span>
                    </OverlayTrigger>
                </>
            }
            {(props.from=='pos') ?
                (!props.supplementListDetail) ?
                    <>
                        <div className="col-12 rounded raccourciPos text-white bg-danger" style={{"border": "1px solid #000"}} onClick={() => props.action(false,props.multiple_choice)}>
                            <div className="textAlign" style={{width:'100%', height:'100px'}}>
                                {t('noSelection')}
                            </div>
                        </div>
                    </>
                :
                    <>
                        <div className="col-12 rounded raccourciPos text-white styleImgRaccourci" onClick={() => props.action(props.supplementListDetail.article,props.multiple_choice)}>
                            <div className="textAlign" style={{width:'100%', height:'100px'}}>
                                {(props.supplementListDetail.article.image==null) ?
                                    props.supplementListDetail.article.name
                                :
                                    <img src={props.supplementListDetail.article.image.split(';')[0]} alt={props.supplementListDetail.article.name} className="imgRaccourci"/>
                                }
                            </div>
                        </div>
                        {(props.supplementListDetail.article.image!=null) &&
                            <div className="itemTitle pointer text-center rounded-bottom" onClick={() => props.action(props.supplementListDetail.article,props.multiple_choice)}>{props.supplementListDetail.article.name}</div>
                        }
                    </>
            :
                <>
                    <div className="col-12 rounded raccourciPos text-white styleImgRaccourci" onClick={() => props.action(props.supplementListDetail.article)}>
                        <div className="textAlign" style={{width:'100%', height:'100px'}}>
                            {(props.supplementListDetail.article.image==null) ?
                                props.supplementListDetail.article.name
                            :
                                <img src={props.supplementListDetail.article.image.split(';')[0]} alt={props.supplementListDetail.article.name} className="imgRaccourci"/>
                            }
                        </div>
                    </div>
                    <div className="itemTitle pointer text-center rounded-bottom" onClick={() => props.action(props.supplementListDetail.article)}>{props.supplementListDetail.article.name}</div>
                </>
            }
        </>
    )
}

export default SupplementListDetailItem;
